// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

// const toolbar = ['undo redo | fontselect fontsizeselect ']
const toolbar = ['fontselect fontsizeselect searchreplace outdent indent  undo redo  code', ' insertdatetime  forecolor backcolor fullscreen']
// const toolbar = ['undo | bold italic ']

export default toolbar
